import { useAuth } from "@/contexts/AuthContext";
import { defaultCTAs, loggedInCTAs, getRoleLanding, CTAConfig } from "@/lib/navigationConfig";

interface NavCTAResult {
  primaryCTA: CTAConfig;
  secondaryCTA: CTAConfig;
  isLoggedIn: boolean;
}

/**
 * Hook to get role-aware CTAs for navigation
 * Returns different CTAs based on authentication state
 */
export const useNavCTA = (): NavCTAResult => {
  const { user, roles } = useAuth();
  const isLoggedIn = !!user;

  if (isLoggedIn) {
    const dashboardHref = getRoleLanding(roles);
    return {
      primaryCTA: { ...loggedInCTAs.primary, href: dashboardHref },
      secondaryCTA: loggedInCTAs.secondary,
      isLoggedIn,
    };
  }

  return {
    primaryCTA: { label: "Get Started", href: "/auth", variant: "primary" as const },
    secondaryCTA: { label: "Book a Demo", href: "/book-demo", variant: "ghost" as const },
    isLoggedIn,
  };
};

export default useNavCTA;
